/** @jsxImportSource @emotion/react */
import { SerializedStyles, useTheme } from "@emotion/react";
import { CSSProperties, ForwardedRef, forwardRef, MouseEventHandler, ReactElement, ReactNode } from "react";

export type BoxProps = {
  children?: ReactElement | ReactNode | string | number;
  style?: CSSProperties | SerializedStyles;
  id?: string;
  hoverStyle?: CSSProperties;
  focusedStyle?: CSSProperties;
  activeStyle?: CSSProperties;
  beforeStyle?: CSSProperties;
  afterStyle?: CSSProperties;
  onClick?: MouseEventHandler;
} & CSSProperties;

export default forwardRef(function Box({ children, style, id, onClick, hoverStyle, focusedStyle, activeStyle, beforeStyle, afterStyle, ...cssProps }: BoxProps, ref: ForwardedRef<HTMLDivElement>) {
  
  const theme = useTheme();

  return (
    <div
      ref={ref}
      id={id}
      onClick={onClick}
      css={{
        ...cssProps,
        ...style,
        '&:hover': {
          ...hoverStyle,
        },
        '&:focused': {
          ...focusedStyle,
        },
        '&:active': {
          ...activeStyle,
        },
        '&::before': {
          ...beforeStyle
        },
        '&::after': {
          ...afterStyle
        }
      }}
    >
      {children}
    </div>
  )
});